import React, { useEffect, useRef, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import pen from '../../assets/icons/pen.svg'
import delet from '../../assets/icons/trash.svg'
import eye from '../../assets/icons/eyeOutline.svg'
import closedeye from '../../assets/icons/closedEye.svg'
import EditCategory from './EditCategory'
import DeletCategory from './DeletCategory'
import editCategory from '../../apis/editCategory'

const CategotyMenu = ({
  active,
  close,
  category,
  updateCategory,
  removeCategory,
}) => {
  const menuRef = useRef(null)
  const [editActive, setEditActive] = useState(false)
  const [deletActive, setDeletActive] = useState(false)
  const [activeLoading, setActiveLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [menuRef, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  const toggleActive = async () => {
    setActiveLoading(true)
    try {
      let data = { is_active: category.is_active === 1 ? 0 : 1 }
      if (data.is_active === 0) {
        data = {
          is_active: 0,
          is_show: 0,
        }
      }

      await editCategory(data, category.id)

      updateCategory({
        ...category,
        ...data,
      })
      close()
    } catch (error) {
      console.log(error)
    } finally {
      setActiveLoading(false)
    }
  }
  const toggleShow = async () => {
    setLoading(true)
    try {
      const newShownStatus = category.is_show === 1 ? 0 : 1
      await editCategory({ is_show: newShownStatus }, category.id)

      updateCategory({ ...category, is_show: newShownStatus })
      close()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <div ref={menuRef}>
      <motion.div
        className=" w-[150px] z-40 rounded-xl flex flex-col bg-white shadow  absolute top-[20%] right-[5%]"
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
      >
        <div className=" flex cursor-pointer gap-1 w-full p-2 border-b-[1px] border-gray">
          <img src={pen} alt="" className=" w-[13%]" />
          <div
            className=" w-10/12 text-blueButton"
            onClick={() => setEditActive(true)}
          >
            Edit
          </div>
        </div>

        <div className=" flex cursor-pointer gap-1 w-full p-2 border-b-[1px] border-gray">
          <img src={delet} alt="" className=" w-[13%]" />
          <div
            className=" w-10/12 text-red"
            onClick={() => setDeletActive(true)}
          >
            Delete
          </div>
        </div>

        {category.is_active === 0 ? (
          <div
            onClick={toggleActive}
            className={`${
              activeLoading ? ' bg-overlay' : ''
            } flex cursor-pointer gap-1 w-full p-2 border-b-[1px] border-gray`}
          >
            {activeLoading ? (
              <div
                style={{
                  borderColor: `#fff transparent #fff transparent`,
                }}
                className=" border-2 w-[13%] aspect-square animate-spin rounded-full "
              ></div>
            ) : (
              <img src={eye} alt="" className=" w-[13%]" />
            )}
            <div className={` w-10/12 text-blueButton`}>Show Category</div>
          </div>
        ) : (
          <div
            onClick={toggleActive}
            className={`${
              activeLoading ? ' bg-overlay' : ''
            } flex cursor-pointer gap-1 w-full p-2 border-b-[1px] border-gray`}
          >
            {activeLoading ? (
              <div
                style={{
                  borderColor: `#fff transparent #fff transparent`,
                }}
                className=" border-2 w-[13%] aspect-square animate-spin rounded-full "
              ></div>
            ) : (
              <img src={closedeye} alt="" className=" w-[13%]" />
            )}
            <div className={` w-10/12 text-blueButton`}>Hide Category</div>
          </div>
        )}

        {category.is_show === 0 ? (
          <button
            disabled={category.is_active === 0 ? true : false}
            onClick={toggleShow}
            className={`${
              loading ? ' bg-overlay' : ''
            } flex relative items-center rounded-b-xl group cursor-pointer gap-1 w-full p-2 disabled:bg-overlay disabled:cursor-default `}
          >
            {category.is_active === 0 && (
              <div className=" opacity-0 group-hover:opacity-100 transition-all duration-200 absolute bg-white z-10 w-full top-1/4 rounded shadow left-3/4">
                it should be active
              </div>
            )}
            {loading ? (
              <div
                style={{
                  borderColor: `#fff transparent #fff transparent`,
                }}
                className=" border-2 w-[13%] aspect-square animate-spin rounded-full "
              ></div>
            ) : (
              <img src={eye} alt="" className=" w-[13%]" />
            )}
            <div className={` w-10/12 text-blueButton`}>Show in Home</div>
          </button>
        ) : (
          <div
            onClick={toggleShow}
            className={`${
              loading ? ' bg-overlay' : ''
            } flex cursor-pointer gap-1 w-full p-2`}
          >
            {loading ? (
              <div
                style={{
                  borderColor: `#fff transparent #fff transparent`,
                }}
                className=" border-2 w-[13%] aspect-square animate-spin rounded-full "
              ></div>
            ) : (
              <img src={closedeye} alt="" className=" w-[13%]" />
            )}
            <div className={` w-10/12 text-blueButton`}>Hide in Home</div>
          </div>
        )}
      </motion.div>

      <AnimatePresence>
        {editActive && (
          <EditCategory
            active={editActive}
            close={() => setEditActive(false)}
            categoty={category}
            updateCategory={updateCategory}
          />
        )}
        {deletActive && (
          <DeletCategory
            active={deletActive}
            close={() => setDeletActive(false)}
            categoty={category}
            removeCategory={removeCategory}
          />
        )}
      </AnimatePresence>
    </div>
  )
}

export default CategotyMenu
